import config from 'config';
import { SuccessResponse } from 'core/http/response';
import { Declaration } from 'store/declarations/declaration';
import axiosClient from '../../config/axios';

export const addProductsTemplatesToIrelandH1 = (
    declarationId: string,
    productTemplateIds: string[]
): Promise<Declaration> => {
    return axiosClient
        .post<SuccessResponse<Declaration>>(
            `${config.declarationsUrl}/ireland/import/declarations/${declarationId}/product-templates`,
            {
                productTemplateIds,
            }
        )
        .then((response) => response.data.payload);
};

export const addProductsTemplatesToIrelandH7 = (
    declarationId: string,
    productTemplateIds: string[]
): Promise<Declaration> => {
    return axiosClient
        .post<SuccessResponse<Declaration>>(
            `${config.declarationsUrl}/ireland/import/declarations/${declarationId}/h7/product-templates`,
            {
                productTemplateIds,
            }
        )
        .then((response) => response.data.payload);
};

export const addProductsTemplatesToIrelandENS = (
    declarationId: string,
    productTemplateIds: string[]
): Promise<Declaration> => {
    return axiosClient
        .post<SuccessResponse<Declaration>>(
            `${config.declarationsUrl}/ireland/ens/declarations/${declarationId}/product-templates`,
            {
                productTemplateIds,
            }
        )
        .then((response) => response.data.payload);
};

export const addProductsTemplatesToIrelandExport = (
    declarationId: string,
    productTemplateIds: string[]
): Promise<Declaration> => {
    return axiosClient
        .post<SuccessResponse<Declaration>>(
            `${config.declarationsUrl}/ie/export/declarations/${declarationId}/product-templates`,
            {
                productTemplateIds,
            }
        )
        .then((response) => response.data.payload);
};

export const addProductsTemplatesToUk = (declarationId: string, productTemplateIds: string[]): Promise<Declaration> => {
    return axiosClient
        .post<SuccessResponse<Declaration>>(
            `${config.declarationsUrl}/uk/declarations/${declarationId}/product-templates`,
            {
                productTemplateIds,
            }
        )
        .then((response) => response.data.payload);
};
